import { tabsAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
// eslint-disable-next-line @typescript-eslint/unbound-method -- Complaining about `this` in Chakra functions?
const { defineMultiStyleConfig , definePartsStyle  } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle({
    tab: {
        _selected: {
            borderColor: 'fill.interactive',
            textStyle: 'lBold'
        },
        borderBottom: '4px',
        borderColor: 'transparent'
    },
    tablist: {
        border: 'none',
        overflowX: 'auto',
        whiteSpace: 'nowrap'
    }
});
const sizes = {
    md: definePartsStyle({
        tab: {
            paddingBottom: 0.5,
            paddingTop: 0,
            paddingX: 0,
            fontSize: 'l'
        }
    })
};
const defaultProps = {
    variant: 'default'
};
export const tabsTheme = defineMultiStyleConfig({
    baseStyle,
    defaultProps,
    sizes
});

//# sourceMappingURL=tabs.js.map